export interface Asset {
  uri: string;
  url: string;
  imageType: ImageType;
}

export const enum ImageType {
  MENU = "MENU",
  GALLERY = "GALLERY",
  POSTER = "POSTER",
  COVER = "COVER",
}

export interface Image extends Partial<Asset> {
  data_url?: string;
  file?: File;
}